import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col, Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import {
    MDTModalWindow,
    MDTCheckbox,
    MDTInput,
    MDTTextarea,
    ErrorBoundary,
    successToast,
    CurrencyWrapper,
} from 'mdt-core-components';
import { isEmpty, get, cloneDeep } from 'lodash';
import { MDTApi } from 'mdt-core-components/src/services/mdtapi';
import {
    sendEventTrackingData,
    getLabelsForTracking,
    pushIntoDigitalData,
    formatDataUsingSeparator,
} from 'mdt-core-components/src/helpers/commonUtils';
import './rpv.css';

export class ReportPriceVariance extends PureComponent {
    constructor(props) {
        super(props);
        this.updatePhoneNumberFromProfile = this.updatePhoneNumberFromProfile.bind(this);
        this.selectRow = this.selectRow.bind(this);
        this.copyMail = this.copyMail.bind(this);
        this.contactNumber = this.contactNumber.bind(this);
        this.contactNumberOnBlur = this.contactNumberOnBlur.bind(this);
        this.expectedPrice = this.expectedPrice.bind(this);
        this.expectedPriceBlur = this.expectedPriceBlur.bind(this);
        this.contractNumber = this.contractNumber.bind(this);
        this.contractNumberBlur = this.contractNumberBlur.bind(this);
        this.userComments = this.userComments.bind(this);
        this.submitRpv = this.submitRpv.bind(this);
        this.lineItemValidation = this.lineItemValidation.bind(this);
        this.sendRpv = this.sendRpv.bind(this);
        this.rpvSuccessCallback = this.rpvSuccessCallback.bind(this);

        this.state = {
            copymail: false,
            contactNumber: '',
            contactNumberValidation: false,
            itemList: cloneDeep(this.props.itemList),
            userEmailId: '',
            userName: '',
            expectPrice: [],
            validateExpPrice: false,
            validateContactNumber: false,
        };
    }

    componentWillMount() {
        this.updatePhoneNumberFromProfile(this.props.userDetails);
    }

    updatePhoneNumberFromProfile(userDetails) {
        const contactNumber = get(userDetails, 'addresses[0].phone', '');
        const userEmailId = get(userDetails, 'email', '');
        const userName = `${get(userDetails, 'firstName', '')} ${get(userDetails, 'lastName', '')}`;

        if (contactNumber) {
            this.setState({
                validateContactNumber: !!contactNumber.match(
                    /^(\+\d{1,3})?[\s]?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
                ),
            });
        }
        this.setState({ contactNumber, userEmailId, userName });
    }

    userComments(value, index) {
        const itemList = cloneDeep(this.state.itemList);
        itemList[index].comments = value;

        this.setState({ itemList });
    }

    expectedPrice(val, valid, index) {
        const itemList = cloneDeep(this.state.itemList);
        const rpvReqFieldObject = [];
        itemList[index].expectedPrice = val;

        this.setState({
            validateExpPrice: !!val.match(/^[1-9]\d{0,7}(?:\.\d{1,4})?$/),
        });

        itemList.map((item) => {
            if (item.checked) {
                const obj = {
                    expectedPrice: item.expectedPrice || '',
                };

                rpvReqFieldObject.push(Object.assign({}, obj));
            }
        });
        this.setState({ expectPrice: rpvReqFieldObject });
    }

    expectedPriceBlur(e, valid, index) {
        const itemList = cloneDeep(this.state.itemList);
        itemList[index].expectedPrice = e.target.value;
        itemList[index].expectedPriceValidation = !valid;

        this.setState({ itemList });
    }

    contractNumber() {}

    contractNumberBlur(e, valid, index) {
        const itemList = cloneDeep(this.state.itemList);
        itemList[index].contractNumber = e.target.value;

        this.setState({ itemList });
    }

    copyMail(checked) {
        this.setState({ copymail: checked });
    }

    contactNumberOnBlur(e, valid) {
        this.setState({ contactNumber: e.target.value, contactNumberValidation: !valid });
    }

    contactNumber(val) {
        this.setState({
            validateContactNumber: !!val.match(
                /^(\+\d{1,3})?[\s]?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
            ),
        });
        this.setState({ contactNumber: val });
    }

    selectRow(checked, index) {
        const itemList = cloneDeep(this.state.itemList);
        itemList[index].checked = checked;

        this.setState({ itemList });
    }

    lineItemValidation() {
        const { itemList } = this.state;
        const updateItemList = itemList.map((item) => {
            return Object.assign(item, {
                expectedPriceValidation:
                    typeof item.expectedPriceValidation !== 'undefined'
                        ? item.expectedPriceValidation
                        : true,
            });
        });
        this.setState({ itemList: updateItemList });
        return !!updateItemList.find((obj) => !!obj.expectedPriceValidation && !!obj.checked);
    }

    submitRpv() {
        let valid = true;
        if (this.lineItemValidation()) {
            valid = false;
        }
        if (this.state.contactNumber === '' || this.state.contactNumberValidation) {
            valid = false;
            this.setState({ contactNumberValidation: true });
        }

        if (valid) {
            this.sendRpv();
        }
    }

    getRpvObj() {
        const itemList = cloneDeep(this.state.itemList);
        const rpvObject = [];

        itemList.map((item) => {
            if (item.checked) {
                const { product } = { ...item };
                const obj = {
                    mpgCode: (product && product.mpgCode) || '',
                    productDesc: (product && product.name) || '',
                    vendorPartNumber: (product && product.vendorPartNumber) || '',
                    productName: (product && product.name) || '',
                    quantity: item.product.qty,
                    currentPrice: (product && product.price) || '',
                    expectedPrice: item.expectedPrice || '',
                    contract: item.contractNumber || '',
                    comments: item.comments,
                    supplier: (product && product.suppliers) || [],
                    uom:
                        product && product.salesUOM
                            ? { code: product.salesUOM.code, name: product.salesUOM.name }
                            : {},
                    code: product.code || '',
                };

                rpvObject.push(Object.assign({}, obj));
            }
        });
        return rpvObject;
    }

    sendRpv() {
        const productsCollection = this.getRpvObj();
        const rpvInfo = productsCollection.map((obj) => {
            return {
                productCFN: obj.vendorPartNumber,
                productDesc: obj.productDesc,
                quantity: obj.quantity,
                unitPrice: obj.uom.name,
                totalPrice: obj.currentPrice,
                availability: obj.availability,
            };
        });
        const transactionalProducts = formatDataUsingSeparator(rpvInfo);
        pushIntoDigitalData(transactionalProducts);
        const data = {
            isCopyRequested: this.state.copymail,
            phoneNumber: this.state.contactNumber,
            products: productsCollection,
            soldToId: get(this.props, 'soldTo.id', ''),
            soldToName: get(this.props, 'soldTo.name', ''),
        };
        const productsLabels = getLabelsForTracking(productsCollection, 'code');
        const eventParamObj = this.props.eventParamObjProps
            ? this.props.eventParamObjProps
            : {
                  eventCategory: 'browseAndShop',
                  eventAction: 'rpv',
                  eventLabel: {
                      label: productsLabels,
                      name: 'rpvLabelsOnSubmit',
                  },
              };

        sendEventTrackingData(eventParamObj);
        if (Array.isArray(productsCollection) && productsCollection.length > 0) {
            MDTApi.call('api.reportPriceVariance.rpv', {
                method: 'POST',
                data: data,
                successCallback: this.rpvSuccessCallback,
            });
        }
    }

    rpvSuccessCallback() {
        successToast(t('priceVarianceReported'));
        this.props.rpvSuccess && this.props.rpvSuccess();
        this.props.cancelRpv(false);
    }

    returnPrice(product) {
        if (!product || (product.displayBasePrice !== 0 && !product.displayBasePrice)) {
            return undefined;
        }

        return product.displayBasePrice;
    }

    returnUOM(product) {
        const { t } = this.props;
        let uom = (product.salesUOM && product.salesUOM.code) || '';
        uom = !!uom ? t(`unit.${uom}`) : '';

        return ` ${uom}`;
    }

    render() {
        const { t, className } = this.props;

        const { expectPrice, contactNumber, contactNumberValidation, copymail, itemList } =
            this.state;

        const rpvFormValidation = !(
            !isEmpty(expectPrice) &&
            itemList.some((item) => item.checked === true) &&
            expectPrice.every((item) => !isEmpty(item.expectedPrice)) &&
            !!contactNumber
        );

        const ePrice = {
            label: t('expectedPrice'),
            name: 'mdt-input',
            disabled: false,
            errorMessage: t('requiredError'),
            required: true,
            regexValidate: true,
            regex: /^[1-9]\d{0,7}(?:\.\d{1,4})?$/,
            regexErrorMessage: t('error.invalidPrice'),
        };
        const eNumber = {
            label: t('expectedContractNumber'),
            name: 'mdt-input',
            disabled: false,
            errorMessage: t('requiredError'),
            validate: false,
        };
        const phoneProps = {
            label: t('contactNumber'),
            name: 'mdt-input',
            disabled: false,
            value: contactNumber,
            errorMessage: t('requiredError'),
            validate: contactNumberValidation,
            required: true,
            regexValidate: true,
            regex: /^(\+\d{1,3})?[\s]?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
            regexErrorMessage: t('error.invalidPhoneNumber'),
        };
        const checkboxProps = {
            label: t('copyEmail'),
            onChange: (checked) => this.copyMail(checked),
            className: 'mdt-checkbox',
            labelClassName: 'body1 rpv-copy-email',
            checked: copymail,
        };
        const rpvModalProps = {
            title: t('reportPriceVariance'),
            icon: 'cross',
            defaultOpen: true,
            toggleWindow: (flag) => this.props.toggleRPVModal(flag),
            customClass: 'mdt-modal-window',
            modalInCenter: true,
            isCancelButtonRequired: true,
            submitButtonName: t('submit'),
            isSubmitDisabled:
                rpvFormValidation ||
                !this.state.validateExpPrice ||
                !this.state.validateContactNumber,
            onClick: () => this.submitRpv(),
        };

        return (
            <ErrorBoundary>
                <MDTModalWindow {...rpvModalProps}>
                    <Container className='rpv-container'>
                        <Row className={className}>
                            <Col className='report-price-variance'>
                                <Row>
                                    <Col xs={12}>
                                        <span data-test='contractPriceIncorrect' className='body1'>
                                            {t('contractPriceIncorrect')}
                                        </span>
                                    </Col>
                                </Row>
                                <hr className='rpv-extra-actions' />
                                <Row className='list-section'>
                                    {!isEmpty(itemList) &&
                                        itemList.map((item, index) => {
                                            const price = this.returnPrice(item.product);
                                            return (
                                                <Col
                                                    xs={12}
                                                    key={`rpv-${index}`}
                                                    className='item-list'
                                                >
                                                    <Row className='item-header'>
                                                        <Col xs={12}>
                                                            <div>
                                                                <span
                                                                    data-test={`cfnNumber-${index}`}
                                                                    className='body1 cfn-number text-transform-none m-emphasis'
                                                                >
                                                                    {t('item')}:{' '}
                                                                    {item.product.vendorPartNumber}
                                                                </span>
                                                            </div>
                                                            <div
                                                                data-test={`productName-${index}`}
                                                                className='item-number-text'
                                                            >
                                                                <h3>{item.product.name}</h3>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className='item-body'>
                                                        <Col
                                                            xs={12}
                                                            sm={3}
                                                            md={3}
                                                            className='list-col price-before'
                                                        >
                                                            <div className='body2 heading display-price-label'>
                                                                {t('displayedPrice')}
                                                            </div>
                                                            <div
                                                                data-test={`displayPriceValue-${index}`}
                                                                className='body1 text display-price-value'
                                                                id='displayPrice'
                                                            >
                                                                <CurrencyWrapper
                                                                    isoCode={item.priceUnit || 'US'}
                                                                    value={price}
                                                                    uom={this.returnUOM(
                                                                        item.product
                                                                    )}
                                                                    zeroPriceValid={price === 0}
                                                                />
                                                            </div>
                                                        </Col>
                                                        <Col
                                                            xs={12}
                                                            sm={9}
                                                            md={9}
                                                            className='price-after'
                                                        >
                                                            <Row className='mx-0'>
                                                                <Col
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={6}
                                                                    className='list-col'
                                                                    id='expectedPrice'
                                                                >
                                                                    <MDTInput
                                                                        {...ePrice}
                                                                        dataTest={`expectedPrice-${index}`}
                                                                        customeRequiredFieldClass='mdt-label'
                                                                        validate={
                                                                            !!item.expectedPriceValidation
                                                                        }
                                                                        onChange={(value, valid) =>
                                                                            this.expectedPrice(
                                                                                value,
                                                                                valid,
                                                                                index
                                                                            )
                                                                        }
                                                                        onBlur={(e, valid) =>
                                                                            this.expectedPriceBlur(
                                                                                e,
                                                                                valid,
                                                                                index
                                                                            )
                                                                        }
                                                                    />
                                                                </Col>
                                                                <Col
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={6}
                                                                    className='list-col'
                                                                    id='expectedContractNumber'
                                                                >
                                                                    <MDTInput
                                                                        {...eNumber}
                                                                        dataTest={`expectedContractNumber-${index}`}
                                                                        onChange={(value, valid) =>
                                                                            this.contractNumber(
                                                                                value,
                                                                                valid,
                                                                                index
                                                                            )
                                                                        }
                                                                        onBlur={(e, valid) =>
                                                                            this.contractNumberBlur(
                                                                                e,
                                                                                valid,
                                                                                index
                                                                            )
                                                                        }
                                                                    />
                                                                </Col>
                                                            </Row>
                                                            <Row className='mx-0'>
                                                                <Col
                                                                    xs={12}
                                                                    className='list-col'
                                                                    data-test={`comments-${index}`}
                                                                    id='comments'
                                                                >
                                                                    <MDTTextarea
                                                                        disabled={false}
                                                                        errorMessage={t(
                                                                            'error.comments'
                                                                        )}
                                                                        label={t('comments')}
                                                                        name='mdt-textarea'
                                                                        onBlur={(value) =>
                                                                            this.userComments(
                                                                                value,
                                                                                index
                                                                            )
                                                                        }
                                                                        rows='1'
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <hr className='rpv-extra-actions' />
                                                </Col>
                                            );
                                        })}
                                </Row>
                                <Row>
                                    <Col xs={12} sm={8} md={8} id='contactNumber'>
                                        <MDTInput
                                            {...phoneProps}
                                            dataTest='contactNumber'
                                            onChange={(value, valid) =>
                                                this.contactNumber(value, valid)
                                            }
                                            onBlur={(e, valid) =>
                                                this.contactNumberOnBlur(e, valid)
                                            }
                                        />
                                        <span
                                            data-test='profileVisit'
                                            className='body3 assistive-text'
                                        >
                                            {t('profileVisit')}
                                            <span className='text-lowercase'>{` ${t('phoneNumberUpdate')}.`}</span>
                                        </span>
                                    </Col>
                                    <Col xs={12} sm={4} md={4} className='align-self-center'>
                                        <div
                                            className='send-email'
                                            data-test='sendEmail'
                                            id='sendEmail'
                                        >
                                            <MDTCheckbox {...checkboxProps} />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </MDTModalWindow>
            </ErrorBoundary>
        );
    }
}

ReportPriceVariance.propTypes = {
    downloadParam: PropTypes.object,
    uploadPathVar: PropTypes.object,
    uploadTitle: PropTypes.string,
};

ReportPriceVariance.defaultProps = {
    downloadParam: {},
    uploadPathVar: {},
    uploadTitle: 'uploadExcel',
};

function mapStateToProps(state) {
    return {
        userDetails: state.AccountDetails.user || {},
        pageName: state.page,
        soldTo: get(state, 'meDetails.defaultCustomer.soldTo', {}),
    };
}

function mapDispatchToProps() {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReportPriceVariance));
